import React from 'react';
import { motion } from 'framer-motion';

const COACH_IMG = 'https://customer-assets.emergentagent.com/job_elite-coaching-15/artifacts/mwx0i58x_WhatsApp%20Image%202026-03-02%20at%209.33.47%20PM.jpeg';

export const CoachPreview = () => {
  return (
    <section id="coach" data-testid="coach-preview" className="bg-black py-16 px-6">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="rounded-2xl border border-neutral-800 bg-neutral-950 overflow-hidden grid lg:grid-cols-[2fr_3fr]"
        >
          <div className="relative min-h-[320px] lg:min-h-[420px]">
            <img src={COACH_IMG} alt="Alou Dillon" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent lg:bg-gradient-to-r lg:from-transparent lg:to-neutral-950" />
          </div>

          <div className="p-8 sm:p-12 flex flex-col justify-center">
            <p className="text-gray-400 font-bold text-xs tracking-[0.3em] uppercase mb-2">
              The Coach Behind The Blueprint
            </p>
            <div className="w-12 h-0.5 bg-gray-400 mb-6" />
            <h2 data-testid="coach-heading" className="font-display text-white text-4xl sm:text-5xl uppercase mb-3">
              Meet Alou Dillon
            </h2>
            <div className="w-16 h-1 bg-gray-400 mb-6" />
            <p className="text-gray-300 text-base md:text-lg leading-relaxed">
              Alou Dillon is a former NCAA Division I and professional basketball player turned Basketball,
              Fitness &amp; Mindset Coach. Through The Dillon Blueprint, he helps serious basketball players reach
              the next level and helps women 30+ get strong, lean, and athletic again—combining proven training,
              accountability, and an athlete's mindset to build the strongest version of each client.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
